import React from 'react';
import Icon from '../../../components/AppIcon';

const ActivityFeed = () => {
  const activities = [
    {
      type: 'signup',
      title: 'New Client Registration',
      description: 'TechCorp Solutions signed up for Growth plan',
      timestamp: '5 minutes ago',
      icon: 'UserPlus',
      color: 'emerald'
    },
    {
      type: 'subscription',
      title: 'Plan Upgrade',
      description: 'Innovate Labs upgraded from Growth to Scale plan',
      timestamp: '23 minutes ago',
      icon: 'TrendingUp',
      color: 'violet'
    },
    {
      type: 'payment',
      title: 'Payment Received',
      description: 'Digital Ventures - ₹24,999 (Annual subscription)',
      timestamp: '1 hour ago',
      icon: 'CheckCircle',
      color: 'blue'
    },
    {
      type: 'subscription',
      title: 'Subscription Cancelled',
      description: 'StartupHub cancelled their subscription',
      timestamp: '2 hours ago',
      icon: 'XCircle',
      color: 'red'
    },
    {
      type: 'signup',
      title: 'New Client Registration',
      description: 'CloudScale Inc signed up for Free plan',
      timestamp: '3 hours ago',
      icon: 'UserPlus',
      color: 'emerald'
    },
    {
      type: 'payment',
      title: 'Payment Failed',
      description: 'RetryTech - ₹2,499 (Card declined)',
      timestamp: '4 hours ago',
      icon: 'AlertCircle',
      color: 'amber'
    }
  ];

  const iconColors = {
    emerald: '#10B981',
    violet: '#8B5CF6',
    blue: '#3B82F6',
    red: '#EF4444',
    amber: '#F59E0B'
  };

  const bgColors = {
    emerald: 'bg-emerald-500/10',
    violet: 'bg-violet-500/10',
    blue: 'bg-blue-500/10',
    red: 'bg-red-500/10',
    amber: 'bg-amber-500/10'
  };

  return (
    <div className="bg-white border border-slate-200 rounded-xl p-6 elevation-sm">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-lg font-bold text-slate-900 font-heading">
            Recent Activity
          </h3>
          <p className="text-sm text-slate-600 font-body mt-1">
            Latest platform events and transactions
          </p>
        </div>
        <button className="text-sm font-medium text-violet-600 hover:text-violet-700 transition-colors">
          View All
        </button>
      </div>

      <div className="space-y-4">
        {activities?.map((activity, index) => (
          <div
            key={index}
            className="flex items-start gap-4 p-4 rounded-lg hover:bg-slate-50 transition-colors"
          >
            <div className={`w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 ${bgColors?.[activity?.color]}`}>
              <Icon name={activity?.icon} size={20} color={iconColors?.[activity?.color]} />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-semibold text-slate-900 mb-1">
                {activity?.title}
              </p>
              <p className="text-sm text-slate-600">
                {activity?.description}
              </p>
              <p className="text-xs text-slate-500 mt-2">
                {activity?.timestamp}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ActivityFeed;